<template>
    <div>
     <b-modal :id="modalId" size="xl" scrollable  :title="TitleModal" @ok="this.emitEventOK" @cancel="this.emitEventCancel" @hide="resetModal" :cancel-title="$t('Shared.BtnCancel')"> 
     
        <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
            <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
              <div class="tab-pane fade show active" id="diag1_4" role="tabpanel">
                <b-row>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode1"
                       v-bind:ModelDescription="adm.diagnosis.diagCode1Description"
                       v-bind:RefCode="'DiagnosisAdmitting'"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '1'})"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:FieldCode="'code'"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldDescription="'name'"                   
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '1'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidAdmittingCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                  <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode2"
                       v-bind:ModelDescription="adm.diagnosis.diagCode2Description"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '2'})"
                       v-bind:Fields="BaseFields"
                       v-bind:RefCode="'DiagnosisPrimary'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                     
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '2'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidPrimaryCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode3"
                       v-bind:ModelDescription="adm.diagnosis.diagCode3Description"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '3'})"
                       v-bind:RefCode="'Diagnosis3'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                      
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '3'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode4"
                       v-bind:ModelDescription="adm.diagnosis.diagCode4Description"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '4'})"
                       v-bind:RefCode="'Diagnosis4'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                     
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '4'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                </b-row>
              </div>
              <div class="tab-pane fade" id="diag5_8" role="tabpanel">
                 <b-row>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode5"
                       v-bind:ModelDescription="adm.diagnosis.diagCode5Description"
                       v-bind:RefCode="'Diagnosis5'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:FieldCode="'code'"
                       v-bind:Fields="BaseFields"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '5'})"
                       v-bind:FieldDescription="'name'"                       
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '5'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidAdmittingCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                  <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode6"
                       v-bind:ModelDescription="adm.diagnosis.diagCode6Description"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '6'})"
                       v-bind:RefCode="'Diagnosis6'"
                       v-bind:Fields="BaseFields"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                      
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '6'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidPrimaryCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode7"
                       v-bind:ModelDescription="adm.diagnosis.diagCode7Description"
                       v-bind:RefCode="'Diagnosis7'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '7'})"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                      
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '7'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode8"
                       v-bind:ModelDescription="adm.diagnosis.diagCode8Description"
                       v-bind:RefCode="'Diagnosis8'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '8'})"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                    
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '8'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                </b-row>
              </div>
              <div class="tab-pane fade" id="diag9_12" role="tabpanel">
              <b-row>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode9"
                       v-bind:ModelDescription="adm.diagnosis.diagCode9Description"
                       v-bind:RefCode="'Diagnosis9'"
                       v-bind:Fields="BaseFields"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:FieldCode="'code'"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '8'})"
                       v-bind:FieldDescription="'name'"                       
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '9'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidAdmittingCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                  <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode10"
                       v-bind:ModelDescription="adm.diagnosis.diagCode10Description"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '10'})"
                       v-bind:Fields="BaseFields"
                       v-bind:RefCode="'Diagnosis10'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                       
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '10'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidPrimaryCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode11"
                       v-bind:ModelDescription="adm.diagnosis.diagCode11Description"
                       v-bind:RefCode="'Diagnosis11'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '11'})"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'description'"                     
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '11'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode12"
                       v-bind:ModelDescription="adm.diagnosis.diagCode12Description"
                       v-bind:RefCode="'Diagnosis12'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '12'})"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                     
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '12'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
              </b-row>
              </div>
              <div class="tab-pane fade" id="diag13_16" role="tabpanel">
                 <b-row>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode13"
                       v-bind:ModelDescription="adm.diagnosis.diagCode13Description"
                       v-bind:RefCode="'Diagnosis13'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldCode="'code'"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '13'})"
                       v-bind:FieldDescription="'name'"                       
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '13'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidAdmittingCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                  <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode14"
                       v-bind:ModelDescription="adm.diagnosis.diagCode14Description"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '14'})"
                       v-bind:RefCode="'Diagnosis14'"
                       v-bind:Fields="BaseFields"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                      
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '14'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidPrimaryCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode15"
                       v-bind:ModelDescription="adm.diagnosis.diagCode15Description"
                       v-bind:RefCode="'Diagnosis15'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '15'})"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                     
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '15'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode16"
                       v-bind:ModelDescription="adm.diagnosis.diagCode16Description"
                       v-bind:RefCode="'Diagnosis16'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '16'})"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                                      
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '16'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                </b-row>
              </div>
              <div class="tab-pane fade" id="diag17_20" role="tabpanel">
                 <b-row>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode17"
                       v-bind:ModelDescription="adm.diagnosis.diagCode17Description"
                       v-bind:RefCode="'Diagnosis17'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldCode="'code'"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '17'})"
                       v-bind:FieldDescription="'name'"                       
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '17'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidAdmittingCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                  <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode18"
                       v-bind:ModelDescription="adm.diagnosis.diagCode18Description"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '18'})"
                       v-bind:RefCode="'Diagnosis18'"
                       v-bind:Fields="BaseFields"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                      
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '18'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidPrimaryCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode19"
                       v-bind:ModelDescription="adm.diagnosis.diagCode19Description"
                       v-bind:RefCode="'Diagnosis19'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '19'})"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                     
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '19'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode20"
                       v-bind:ModelDescription="adm.diagnosis.diagCode20Description"
                       v-bind:RefCode="'Diagnosis20'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '20'})"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                                      
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '20'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                </b-row>
              </div>
              <div class="tab-pane fade" id="diag21_24" role="tabpanel">
                 <b-row>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode21"
                       v-bind:ModelDescription="adm.diagnosis.diagCode21Description"
                       v-bind:RefCode="'Diagnosis21'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldCode="'code'"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '21'})"
                       v-bind:FieldDescription="'name'"                       
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '21'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidAdmittingCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                  <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode22"
                       v-bind:ModelDescription="adm.diagnosis.diagCode22Description"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '22'})"
                       v-bind:RefCode="'Diagnosis22'"
                       v-bind:Fields="BaseFields"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                      
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '22'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidPrimaryCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode23"
                       v-bind:ModelDescription="adm.diagnosis.diagCode23Description"
                       v-bind:RefCode="'Diagnosis23'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '23'})"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                     
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '23'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode24"
                       v-bind:ModelDescription="adm.diagnosis.diagCode24Description"
                       v-bind:RefCode="'Diagnosis24'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '24'})"
                       v-bind:FieldCode="'code'"
                       v-bind:FieldDescription="'name'"                                      
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '24'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidDiagnosisCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>
                </b-row>
              </div>
              <div class="tab-pane fade" id="diag25" role="tabpanel">
                 <b-row>
                 <b-col lg="3" md="3" sm="12">
                    <MdLookup
                       v-bind:ModelCode="adm.diagnosis.diagCode25"
                       v-bind:ModelDescription="adm.diagnosis.diagCode25Description"
                       v-bind:RefCode="'Diagnosis25'"
                       v-bind:Api="'DiagnosisICD10Providers'"
                       v-bind:Fields="BaseFields"
                       v-bind:FieldCode="'code'"
                       v-bind:Label="$t('Admission.Diagnosis',{'num': '25'})"
                       v-bind:FieldDescription="'name'"                       
                       :SearchTitle="$t('Admission.Diagnosis',{'num': '25'})"
                       :GetValues="onCodeConditionOk"
                       :InvalidFeedback="$t('Admission.InvalidAdmittingCode')"
                       :SearchFieldCode="'Code'"                     
                    />
                 </b-col>                  
                </b-row>
              </div>
              <b-row>
                    <b-col lg="12" md="12" sm="12">
                        <MdMemo
                            v-bind:Label="$tc('Shared.Note', 2)"
                            v-bind:Name="'diagnosis_notes'"
                            v-bind:Rows="'5'"
                            v-bind:MaxRows="'6'"
                            v-bind:MaxLength="'500'"
                            v-bind:VisibleLabel="true"
                            v-model="adm.diagnosis.notes"
                        />
                    </b-col>
                </b-row>
            </div>  
        </MdTabList>
     
     </b-modal>
    </div>
</template>
 
 <script>
 //import GlobalService from '@/services/global.service' 
import { EventBus } from '@/event-bus.js';
import Utils from '@/common/utils'
 
 export default {
   name: 'ModalDiagnosis',
    props: {
      ModalId: String,
      TitleWindow:String,
      PatientCode:String    
    },
    data(){
        return {
            modalId:this.ModalId,
            TitleModal:"",
            Admission:{},
            adm:{
                diagnosis:{
                    diagCode1: "",
                    diagCode1Description:"",
                    diagCode2: "",
                    diagCode2Description:"",
                    diagCode3: "",
                    diagCode3Description:"",
                    diagCode4: "",
                    diagCode4Description:"",
                    diagCode5: "",
                    diagCode5Description:"",
                    diagCode6: "",
                    diagCode6Description:"",
                    diagCode7: "",
                    diagCode7Description:"",
                    diagCode8: "",
                    diagCode8Description:"",
                    diagCode9: "",
                    diagCode9Description:"",
                    diagCode10: "",
                    diagCode10Description:"",
                    diagCode11: "",
                    diagCode11Description:"",
                    diagCode12: "",
                    diagCode12Description:"",
                    diagCode13: "",
                    diagCode13Description:"",
                    diagCode14: "",
                    diagCode14Description:"",
                    diagCode15: "",
                    diagCode15Description:"",
                    diagCode16: "",
                    diagCode16Description:"",
                    diagCode17: "",
                    diagCode17Description:"",
                    diagCode18: "",
                    diagCode18Description:"",
                    diagCode19: "",
                    diagCode19Description:"",
                    diagCode20: "",
                    diagCode20Description:"",
                    diagCode21: "",
                    diagCode21Description:"",
                    diagCode22: "",
                    diagCode22Description:"",
                    diagCode23: "",
                    diagCode23Description:"",
                    diagCode24: "",
                    diagCode24Description:"",
                    diagCode25: "",
                    diagCode25Description:"",
                    notes:""
                }
            },
            tablist: [
                { title: 'Diag 1-4', link: '#diag1_4', active: true},
                { title: 'Diag 5-8', link: '#diag5_8'},
                { title: 'Diag 9-12', link: '#diag9_12'},
                { title: 'Diag 13-16', link: '#diag13_16'},
                { title: 'Diag 17-20', link: '#diag17_20'},
                { title: 'Diag 21-24', link: '#diag21_24'},
                { title: 'Diag 25', link: '#diag25'}
            ],
            BaseFields:[{ key: 'name', sortable: true, label: this.$t('Shared.Description') },{ key: 'code', sortable: true, label: this.$t('Shared.Code')}],
        }
    },
 
    methods:{
      emitEventOK(){  
        this.PrepareDiagnoseList();
       },

       clearAdm(){
        this.adm.diagnosis.diagCode1 = "";
        this.adm.diagnosis.diagCode1Description = "";
        this.adm.diagnosis.diagCode2 = "";
        this.adm.diagnosis.diagCode2Description = "";
        this.adm.diagnosis.diagCode3 = "";
        this.adm.diagnosis.diagCode3Description = "";
        this.adm.diagnosis.diagCode4 = "";
        this.adm.diagnosis.diagCode4Description = "";
        this.adm.diagnosis.diagCode5 = "";
        this.adm.diagnosis.diagCode5Description = "";
        this.adm.diagnosis.diagCode6 = "";
        this.adm.diagnosis.diagCode6Description = "";
        this.adm.diagnosis.diagCode7 = "";
        this.adm.diagnosis.diagCode7Description = "";
        this.adm.diagnosis.diagCode8 = "";
        this.adm.diagnosis.diagCode8Description = "";
        this.adm.diagnosis.diagCode9 = "";
        this.adm.diagnosis.diagCode9Description = "";
        this.adm.diagnosis.diagCode10 = "";
        this.adm.diagnosis.diagCode10Description = "";
        this.adm.diagnosis.diagCode11 = "";
        this.adm.diagnosis.diagCode11Description = "";
        this.adm.diagnosis.diagCode12 = "";
        this.adm.diagnosis.diagCode12Description = "";
        this.adm.diagnosis.diagCode13 = "";
        this.adm.diagnosis.diagCode13Description = "";
        this.adm.diagnosis.diagCode14 = "";
        this.adm.diagnosis.diagCode14Description = "";
        this.adm.diagnosis.diagCode15 = "";
        this.adm.diagnosis.diagCode15Description = "";
        this.adm.diagnosis.diagCode16 = "";
        this.adm.diagnosis.diagCode16Description = ""; 
        this.adm.diagnosis.diagCode17 = "";
        this.adm.diagnosis.diagCode17Description = ""; 
        this.adm.diagnosis.diagCode18 = "";
        this.adm.diagnosis.diagCode18Description = ""; 
        this.adm.diagnosis.diagCode19 = "";
        this.adm.diagnosis.diagCode19Description = ""; 
        this.adm.diagnosis.diagCode20 = "";
        this.adm.diagnosis.diagCode20Description = ""; 
        this.adm.diagnosis.diagCode21 = "";
        this.adm.diagnosis.diagCode21Description = ""; 
        this.adm.diagnosis.diagCode22 = "";
        this.adm.diagnosis.diagCode22Description = "";    
        this.adm.diagnosis.diagCode23 = "";
        this.adm.diagnosis.diagCode23Description = ""; 
        this.adm.diagnosis.diagCode24 = "";
        this.adm.diagnosis.diagCode24Description = ""; 
        this.adm.diagnosis.diagCode25 = "";
        this.adm.diagnosis.diagCode25Description = ""; 
        this.adm.diagnosis.notes = ""; 
       },

       onCodeConditionOk(result){
         var type = result.FieldName;       
         if(type.indexOf('Diagnosis') >= 0) {             
             switch (type) {
                case "DiagnosisAdmitting": 
                  this.adm.diagnosis.diagCode1 = result.code;  
                  this.adm.diagnosis.diagCode1Description = result.description;                    
                  break;
                case "DiagnosisPrimary": 
                  this.adm.diagnosis.diagCode2 = result.code;
                  this.adm.diagnosis.diagCode2Description = result.description;    
                  break;
                case "Diagnosis3": 
                  this.adm.diagnosis.diagCode3 = result.code;   
                  this.adm.diagnosis.diagCode3Description = result.description;   
                  break;
                case "Diagnosis4": 
                  this.adm.diagnosis.diagCode4 = result.code;    
                  this.adm.diagnosis.diagCode4Description = result.description;   
                  break;
                case "Diagnosis5": 
                  this.adm.diagnosis.diagCode5 = result.code;    
                  this.adm.diagnosis.diagCode5Description = result.description;   
                  break;
                case "Diagnosis6": 
                  this.adm.diagnosis.diagCode6 = result.code;   
                  this.adm.diagnosis.diagCode6Description = result.description; 
                  break;
                case "Diagnosis7": 
                  this.adm.diagnosis.diagCode7 = result.code;   
                  this.adm.diagnosis.diagCode7Description = result.description; 
                  break;
                case "Diagnosis8": 
                  this.adm.diagnosis.diagCode8 = result.code; 
                  this.adm.diagnosis.diagCode8Description = result.description; 
                  break;
                case "Diagnosis9": 
                  this.adm.diagnosis.diagCode9 = result.code;
                 this.adm.diagnosis.diagCode9Description = result.description;    
                  break;
                case "Diagnosis10": 
                  this.adm.diagnosis.diagCode10 = result.code; 
                  this.adm.diagnosis.diagCode10Description = result.description;   
                  break;
                case "Diagnosis11": 
                  this.adm.diagnosis.diagCode11 = result.code;   
                   this.adm.diagnosis.diagCode110Description = result.description;     
                  break;
                case "Diagnosis12": 
                  this.adm.diagnosis.diagCode12 = result.code;
                    this.adm.diagnosis.diagCode120Description = result.description;   
                  break;
                case "Diagnosis13": 
                  this.adm.diagnosis.diagCode13 = result.code;                    
                    this.adm.diagnosis.diagCode13Description = result.description;   
                  break;
                case "Diagnosis14": 
                  this.adm.diagnosis.diagCode14 = result.code;   
                    this.adm.diagnosis.diagCode14Description = result.description;   
                  break;
                case "Diagnosis15": 
                  this.adm.diagnosis.diagCode15 = result.code;   
                    this.adm.diagnosis.diagCode15Description = result.description;   
                  break;
                case "Diagnosis16": 
                  this.adm.diagnosis.diagCode16 = result.code;   
                    this.adm.diagnosis.diagCode16Description = result.description;   
                  break;
                case "Diagnosis17": 
                  this.adm.diagnosis.diagCode17 = result.code;   
                    this.adm.diagnosis.diagCode17Description = result.description;   
                  break;
                case "Diagnosis18": 
                  this.adm.diagnosis.diagCode18 = result.code;   
                    this.adm.diagnosis.diagCode18Description = result.description;   
                  break;
                case "Diagnosis19": 
                  this.adm.diagnosis.diagCode19 = result.code;   
                    this.adm.diagnosis.diagCode19Description = result.description;   
                  break;
                case "Diagnosis20": 
                  this.adm.diagnosis.diagCode20 = result.code;   
                    this.adm.diagnosis.diagCode20Description = result.description;   
                  break;
                case "Diagnosis21": 
                  this.adm.diagnosis.diagCode21 = result.code;   
                    this.adm.diagnosis.diagCode21Description = result.description;   
                  break;
                case "Diagnosis22": 
                  this.adm.diagnosis.diagCode22 = result.code;   
                    this.adm.diagnosis.diagCode22Description = result.description;   
                  break;
                case "Diagnosis23": 
                  this.adm.diagnosis.diagCode23 = result.code;   
                    this.adm.diagnosis.diagCode23Description = result.description;   
                  break;
                case "Diagnosis24": 
                  this.adm.diagnosis.diagCode24 = result.code;   
                    this.adm.diagnosis.diagCode24Description = result.description;   
                  break;
                default:
                  this.adm.diagnosis.diagCode25 = result.code;  
                  this.adm.diagnosis.diagCode25Description = result.description;  
             }
         }
     },
 
       emitEventCancel(){
       
       }, 
 
       resetModal(){
 
       },

       PrepareDiagnoseList(){   
        //var new_startDate= new Date(this.Admission.dateFrom);
        var date_result = Utils.formatterToISO(this.Admission.dateFrom, Utils.getShortDateFormat());// moment(new_startDate).format();     
        var obj = {
            RecordId:this.Admission.recordId,
            PatientCode:Utils.isNullOrEmptyString(this.PatientCode) ? this.$route.params.id : this.PatientCode,
            DateFrom:date_result,
            DiagCode1:this.adm.diagnosis.diagCode1,
            DiagCode2:this.adm.diagnosis.diagCode2,
            DiagCode3:this.adm.diagnosis.diagCode3,
            DiagCode4:this.adm.diagnosis.diagCode4,
            DiagCode5:this.adm.diagnosis.diagCode5,
            DiagCode6:this.adm.diagnosis.diagCode6,
            DiagCode7:this.adm.diagnosis.diagCode7,
            DiagCode8:this.adm.diagnosis.diagCode8,
            DiagCode9:this.adm.diagnosis.diagCode9,
            DiagCode10:this.adm.diagnosis.diagCode10,
            DiagCode11:this.adm.diagnosis.diagCode11,
            DiagCode12:this.adm.diagnosis.diagCode12,
            DiagCode13:this.adm.diagnosis.diagCode13,
            DiagCode14:this.adm.diagnosis.diagCode14,
            DiagCode15:this.adm.diagnosis.diagCode15,
            DiagCode16:this.adm.diagnosis.diagCode16,
            DiagCode17:this.adm.diagnosis.diagCode17,
            DiagCode18:this.adm.diagnosis.diagCode18,
            DiagCode19:this.adm.diagnosis.diagCode19,
            DiagCode20:this.adm.diagnosis.diagCode20,
            DiagCode21:this.adm.diagnosis.diagCode21,
            DiagCode22:this.adm.diagnosis.diagCode22,
            DiagCode23:this.adm.diagnosis.diagCode23,
            DiagCode24:this.adm.diagnosis.diagCode24,
            DiagCode25:this.adm.diagnosis.diagCode25,
            Notes:this.adm.diagnosis.notes
        }
        
        EventBus.$emit('onSaveDiagnoses', obj);

       }
 
       
    
    },
 
    mounted(){
        EventBus.$on("onOpenModalDiagnosis", function (admission) { 
            this.Admission = admission;
            this.TitleModal = admission.title;
            var arr = admission.diagnoses;
            var l = arr.length;
            this.clearAdm();     
            this.adm.diagnosis.notes = admission.notes;      
            if(l > 0){
                for(var i = 0; i < l; i++){
                    var pos = i+1;
                    this.adm.diagnosis["diagCode" + pos] = arr[i].code;
                    this.adm.diagnosis["diagCode" + pos+"Description"] = arr[i].description;                  
                }
            }
           
        }.bind(this));
    },

    beforeDestroy () {     
        EventBus.$off('onOpenModalDiagnosis');       
    },
    
 };
 </script>